
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0C2.852 0 0 2.552 0 5.701 0 10.384 4.783 10.88 6 18c1.217-7.121 6-7.616 6-12.299C12 2.552 9.15 0 6 0zm0 8.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5z"}})])
          )
        }
      }
    